var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:_vm.$widgetType,style:(_vm.style)},[_c('v-main',[_c('Modal',{attrs:{"value":_vm.$modals.active}}),_c('div',{staticClass:"container pt-10",class:_vm.$forms.active},[_c('Form',{attrs:{"value":_vm.$forms.active}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }